export const ANALYTICS_TIMEFRAME = Object.freeze({
    LAST_WEEK: "last-week",
    LAST_MONTH: "last-month",
    LAST_QUARTER: "last-quarter",
    LAST_YEAR: "last-year",
    ALL_TIME: "all-time",
  });
  
export const TIMEFRAME_OPTIONS = [
  {
    "timeframeId": 1,
    "timeframe": "last-week"
  },
  {
    "timeframeId": 2,
    "timeframe": "last-month"
  },
  {
    "timeframeId": 3,
    "timeframe": "last-quarter"
  },
  {
    "timeframeId": 4,
    "timeframe": "last-year"
  },
  {
    "timeframeId": 5,
    "timeframe": "all-time"
  }
];
  

export const COMPARISON_TOPICS = [
  {
    "topicId": 1,
    "topicName": "Arts & Culture"
  },
  {
    "topicId": 2,
    "topicName": "Geopolitics"
  },
  {
    "topicId": 3,
    "topicName": "Global Economy"
  },
  {
    "topicId": 4,
    "topicName": "Global Security"
  },
  {
    "topicId": 5,
    "topicName": "Science"
  },
  {
    "topicId": 6,
    "topicName": "Sports"
  },
  {
    "topicId": 7,
    "topicName": "Technology"
  },
  {
    "topicId": 8,
    "topicName": "US Economy"
  },
  {
    "topicId": 9,
    "topicName": "US Politics"
  },
  {
    "topicId": 10,
    "topicName": "Wildcard"
  },
  {
    "topicId": 11,
    "topicName": "Other"
  }
]